import { LAB_REPORT } from "@/api_framework/api_config";
import {
  ILabReportInterpretationListParams,
  ILabReportInterpretationListResponse,
  ILabReportInterpretationListResponseData,
} from "@/api_framework/api_modals/LabReportInterpretation";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";

AxiosCurlirize(axios, () => {});

export const useLabReportInterpretationListAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const [data, setData] = useState<ILabReportInterpretationListResponseData[]>([]);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState(false);

  const execute = useCallback(async (params: ILabReportInterpretationListParams) => {
    const isNextPage = params.page > 1;
    const setRequestLoading = isNextPage ? setLoadingMore : setLoading;
    setRequestLoading(true);
    setError(false);
    const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
    await axios
      .post(LAB_REPORT.LAB_REPORT_INTERPRETATION_LIST.baseURL, params, {
        headers: {
          Authorization: `${accessToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((res: AxiosResponse<ILabReportInterpretationListResponse>) => {
        const rows = res.data?.data?.items ?? [];
        setData((prev) => (isNextPage ? [...prev, ...rows] : rows));
        setHasMore(rows.length === params.page_size);
        if (res.data?.status === false) setError(true);
      })
      .catch((e: AxiosError) => {
        sendCurl(e.config?.["curlCommand"]);
        captureError(e);
        if (!isNextPage) setData([]);
        setHasMore(false);
        setError(true);
      })
      .finally(() => setRequestLoading(false));
  }, []);

  return { execute, data, hasMore, loading, loadingMore, error };
};
